<script lang="ts" setup>
    defineProps<{
        block: CallToActionBlock
    }>()
</script>

<template>
    <CallToAction :content="block.content" :link="block.link" :linkLabel="block.link_label" />
</template>
